<template>
    <div>
        <div id="reward" class="cursor-pointer reward-btn">
            <div class="relative reward-box flex justify-center mb-2">
                <svg
                    id="medal"
                    class="absolute"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="28"
                    height="41"
                    viewBox="0, 0, 400,588.2352941176471"
                >
                    <path
                        id="path0"
                        d="M4.020 4.197 C -1.379 9.596,-4.522 1.567,48.481 117.784 L 94.323 218.301 85.724 224.837 C -71.340 344.212,5.059 586.103,200.000 586.656 C 393.636 587.205,471.208 341.528,314.289 224.694 L 305.703 218.301 352.998 114.481 C 392.968 26.741,399.851 9.836,397.440 5.331 C 392.746 -3.440,260.859 -2.929,255.097 5.882 C 252.981 9.118,240.725 34.883,227.862 63.138 C 214.998 91.393,203.371 116.480,202.024 118.887 C 200.125 122.280,193.556 110.076,172.781 64.559 C 158.043 32.272,144.668 4.538,143.058 2.928 C 137.906 -2.225,9.267 -1.050,4.020 4.197 M87.261 110.696 C 134.087 213.628,130.310 202.641,120.095 206.202 C 112.519 208.843,111.894 208.539,108.524 200.575 C 106.565 195.945,87.816 154.554,66.860 108.595 C 23.584 13.686,25.998 20.915,37.588 20.915 L 46.417 20.915 87.261 110.696 M168.441 104.575 C 189.051 149.869,205.605 187.279,205.227 187.708 C 204.849 188.138,194.106 189.629,181.355 191.022 C 168.603 192.415,155.938 193.828,153.209 194.163 C 148.889 194.693,70.730 32.529,70.613 22.793 C 70.599 21.669,84.173 21.081,100.778 21.486 L 130.967 22.222 168.441 104.575 M329.369 22.876 C 329.345 23.954,311.900 63.072,290.602 109.804 L 251.879 194.771 242.933 193.917 C 231.634 192.839,230.017 191.048,219.635 168.112 L 211.118 149.296 234.057 98.831 C 246.673 71.075,259.745 42.190,263.106 34.641 L 269.215 20.915 299.313 20.915 C 315.868 20.915,329.392 21.797,329.369 22.876 M371.242 22.974 C 371.242 24.107,354.096 62.636,333.140 108.595 C 312.184 154.554,293.435 195.945,291.476 200.575 C 288.106 208.539,287.481 208.843,279.905 206.202 C 269.690 202.641,265.913 213.628,312.739 110.696 L 353.583 20.915 362.412 20.915 C 367.269 20.915,371.242 21.842,371.242 22.974 M252.327 218.067 C 379.663 258.504,420.501 416.135,328.499 512.083 C 235.698 608.865,73.078 571.704,30.239 443.927 C -15.124 308.622,116.371 174.893,252.327 218.067 M161.067 244.502 C 51.069 274.704,14.526 412.491,95.135 493.100 C 213.325 611.290,404.852 474.337,333.193 322.876 C 304.015 261.205,227.358 226.300,161.067 244.502 M236.601 265.481 C 304.755 284.185,344.845 362.413,321.319 430.792 C 291.645 517.041,179.365 545.508,113.721 483.425 C 14.621 389.700,105.017 229.369,236.601 265.481 "
                        stroke="none"
                        fill="var(--ui-color)"
                        fill-rule="evenodd"
                    ></path>
                </svg>
                <svg
                    id="star"
                    class="absolute"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="14"
                    height="14"
                    viewBox="0, 0, 400,400"
                >
                    <path
                        id="path0"
                        class="svg"
                        d="M156.076 57.367 L 128.150 107.955 73.391 119.722 C -12.714 138.226,-15.811 146.059,39.485 205.498 L 78.971 247.941 73.732 295.157 C 62.930 392.512,68.480 397.716,145.617 362.564 L 197.578 338.884 251.724 362.691 C 331.186 397.628,337.353 392.578,325.701 302.113 L 319.642 255.074 359.821 208.507 C 415.090 144.450,412.180 136.294,328.975 122.061 L 277.143 113.195 246.453 59.988 C 205.167 -11.589,194.314 -11.904,156.076 57.367 "
                        stroke="none"
                        fill="var(--ui-color)"
                        fill-rule="evenodd"
                    ></path>
                </svg>
            </div>
            <div id="reward-text" class="underline font-size-16">{{ joinText }}</div>
        </div>
    </div>
</template>

<script>
import gsap from 'gsap'

export default {
    name: 'join-competition',

    props: {
        showAnimate: {
            type: Boolean,
            default: false
        },

        loggedIn: {
            type: Boolean,
            default: false
        }
    },

    mounted() {
        gsap.set('#reward', { opacity: 0 })
    },

    watch: {
        showAnimate() {
            this.addAnimation()
        }
    },

    computed: {
        joinText() {
            return this.loggedIn ? this.$t('join_competition_joined') : this.$t('join_competition_unjoin')
        }
    },

    methods: {
        addAnimation() {
            gsap.set('#reward', { opacity: 1 })
            gsap.set('#reward-text', { opacity: 0 })
            gsap.set('#medal, #star', { opacity: 0, y: 20 })
            gsap.to('#reward-text', { duration: 0.8, opacity: 1 })
            gsap.to('#medal, #star', { duration: 0.8, opacity: 1, y: 0, ease: 'power4.in' })
            gsap.to('#star', { duration: 5, repeat: -1, rotation: 360, ease: 'linear' })
        }
    }
}
</script>

<style lang="scss" scoped>
.reward-btn {
    .reward-box {
        height: 41px;
    }

    #star {
        bottom: 7px;
    }

    &:hover {
        text-decoration: underline;
        filter: drop-shadow(var(--question-shadow));
    }
}
</style>
